export const FILE_UPLOAD_REQUESTED = 'FILE_UPLOAD_REQUESTED';
export const FILE_UPLOAD_SUCCEED = 'FILE_UPLOAD_SUCCEED';
export const FILE_UPLOAD_FAILED = 'FILE_UPLOAD_FAILED';

export const FILE_GOT_REQUESTED = 'FILE_GOT_REQUESTED';
export const FILE_GOT_SUCCEED = 'FILE_GOT_SUCCEED';
export const FILE_GOT_FAILED = 'FILE_GOT_FAILED';

export const FILE_UPLOAD_TO_SEND_REQUESTED = 'FILE_UPLOAD_TO_SEND_REQUESTED';
export const FILE_UPLOAD_TO_SEND_SUCCEED = 'FILE_UPLOAD_TO_SEND_SUCCEED';
export const FILE_UPLOAD_TO_SEND_FAILED = 'FILE_UPLOAD_TO_SEND_FAILED';

export const FILE_UPLOAD_URL_REQUESTED = 'FILE_UPLOAD_URL_REQUESTED';
export const FILE_UPLOAD_URL_SUCCEED = 'FILE_UPLOAD_URL_SUCCEED';
export const FILE_UPLOAD_URL_FAILED = 'FILE_UPLOAD_URL_FAILED';

export const FILE_UPDATE_REQUESTED = 'FILE_UPDATE_REQUESTED';
export const FILE_UPDATE_SUCCEED = 'FILE_UPDATE_SUCCEED';
export const FILE_UPDATE_FAILED = 'FILE_UPDATE_FAILED';

export const HEALTH_SUMMARY_FILE_UPLOAD_REQUESTED = 'HEALTH_SUMMARY_FILE_UPLOAD_REQUESTED';
export const HEALTH_SUMMARY_FILE_UPLOAD_SUCCEED = 'HEALTH_SUMMARY_FILE_UPLOAD_SUCCEED';
export const HEALTH_SUMMARY_FILE_UPLOAD_FAILED = 'HEALTH_SUMMARY_FILE_UPLOAD_FAILED';
